import { BidsDataset, BidsEventFile, BidsJsonFile, BidsSidecar, validateBidsDataset } from '../bids'
import { validateHedDataset } from './dataset'
import { validateHedEvent, validateHedString } from './event'
import { buildSchemas } from './schema/init'

export {
  BidsDataset,
  BidsEventFile,
  BidsJsonFile,
  BidsSidecar,
  validateBidsDataset,
  validateHedDataset,
  validateHedEvent,
  validateHedString,
  buildSchemas,
}

export default {
  BidsDataset,
  BidsEventFile,
  BidsJsonFile,
  BidsSidecar,
  validateBidsDataset,
  validateHedDataset,
  validateHedEvent,
  validateHedString,
  buildSchemas,
}
